// 是否开发环境
export const IS_DEV = /dev/i.test(process.env.NODE_ENV)



// WEBPACK FOOTER //
// ./src/config.js